import { DownloadOutlined, ProjectOutlined } from '@ant-design/icons';
import { Button, Space, Table, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import dayjs from 'libs/dayjs';
import useAuth from 'hooks/useAuth';
import { useActionsODT } from 'providers/ActionsOdtProvider';
import React, { useEffect } from 'react';
import EtapaChip from 'components/ciclo/EtapaChip';
import SectionHint from 'components/ciclo/SectionHint';
import CicloEmpty from 'components/ciclo/CicloEmpty';
import paths from 'assets/routes/paths';

const ODTPage = ({ id }) => {
  const { callODT, orders, dowload: dowloadODT } = useActionsODT();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      callODT(id);
    }
  }, [callODT, id]);

  // Filtrar las órdenes según el tipo de usuario
  const filteredOrders = orders?.filter((order) => {
    if (user.is_administrador) {
      return order.stage === 'finalizada';
    }
    return true; // Mostrar todas las órdenes para otros tipos de usuario
  });
  // Definir las columnas para la tabla
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id_budget',
      key: 'id_budget',
    },
    {
      title: 'Estado',
      dataIndex: 'stage',
      key: 'stage',
      render: (stage) => <EtapaChip kind="budget" stage={stage} />,
    },
    {
      title: 'Dirección',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Comuna',
      dataIndex: 'commune',
      key: 'commune',
    },
    {
      title: 'Cliente',
      dataIndex: 'name_client',
      key: 'name_client',
    },
    {
      title: 'Fecha comprometida',
      dataIndex: 'fecha_comprometida',
      key: 'fecha_comprometida',
      render: (fecha) => (fecha ? dayjs(fecha).format('DD/MM/YYYY') : '—'),
    },
    {
      title: 'Acciones',
      key: 'action',
      render: (item, record) => (
        <Space>
          {item.stage === 'finalizada' ? (
            <Button icon={<DownloadOutlined />} onClick={() => dowloadODT(item.id_budget)}>
              ODT
            </Button>
          ) : null}
          {!user.is_administrador ? (
            <Tooltip title="Planificar en la carta Gantt">
              <Button
                icon={<ProjectOutlined />}
                onClick={() => navigate(paths.admin.odt.gantt(record.id_order))}
              >
                Carta Gantt
              </Button>
            </Tooltip>
          ) : null}
        </Space>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <SectionHint
        id="odt-cliente"
        message="Órdenes de trabajo (ODT) de este cliente"
        description="Cada ODT nace de un presupuesto aprobado. Se ejecutan en terreno y, al cerrarse, resuelven los hallazgos que las originaron."
      />
      <Table
        columns={columns}
        dataSource={filteredOrders}
        rowKey={'id_order'}
        locale={{
          emptyText: (
            <CicloEmpty
              title="Este cliente no tiene ODT todavía"
              description="Las órdenes de trabajo se generan al aprobar un presupuesto. Revisá los presupuestos del cliente."
              ctaLabel="Ir a Presupuestos"
              ctaTo={paths.admin.budget.root}
            />
          ),
        }}
      />
    </div>
  );
};

export default ODTPage;
